import React from 'react';

const PanelContext = React.createContext({
  closePanel: () => {},
  getId: () => '',
  didOpenPanel: () => {},
});

export default PanelContext;
